import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["action"]
const _hoisted_2 = { class: "contact-form__input" }
const _hoisted_3 = { for: "firstName" }
const _hoisted_4 = { class: "contact-form__input" }
const _hoisted_5 = { for: "lastName" }
const _hoisted_6 = { class: "contact-form__input" }
const _hoisted_7 = { for: "contact-phone" }
const _hoisted_8 = { class: "contact-form__input" }
const _hoisted_9 = { for: "contact-email" }
const _hoisted_10 = { class: "contact-form__input contact-form__textarea" }
const _hoisted_11 = { class: "control-label" }
const _hoisted_12 = { class: "contact-form__row" }
const _hoisted_13 = { class: "contact-form__input" }
const _hoisted_14 = {
  class: "checkbox-label",
  for: "contact-checkbox"
}
const _hoisted_15 = { class: "contact-form__button" }
const _hoisted_16 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_recaptcha = _resolveComponent("vue-recaptcha")!

  return (_openBlock(), _createElementBlock("form", {
    ref: "form",
    method: "post",
    action: this.endpointUri,
    lang: "${cmsfn.language()}"
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["contact-form__notification", _ctx.notificationClass]),
      ref: "notificationHolder"
    }, _toDisplayString(this.notification), 3),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", _hoisted_3, _toDisplayString(this.firstNameLabel) + " *", 1),
      _createElementVNode("input", {
        onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleSubmitBtn())),
        type: "text",
        id: "firstName",
        ref: "firstName",
        name: "firstname-contact",
        required: ""
      }, null, 544)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("label", _hoisted_5, _toDisplayString(this.lastNameLabel) + " *", 1),
      _createElementVNode("input", {
        onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleSubmitBtn())),
        type: "text",
        id: "lastName",
        ref: "lastName",
        name: "lastname-contact",
        required: ""
      }, null, 544)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("label", _hoisted_7, _toDisplayString(this.phoneLabel) + " *", 1),
      _createElementVNode("input", {
        onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleSubmitBtn())),
        type: "text",
        id: "contact-phone",
        ref: "phone",
        name: "phone-contact",
        required: "",
        pattern: "^[\\+]?[(]?[0-9]{3}[)]?[-\\s\\.]?[0-9]{3}[-\\s\\.]?[0-9]{4,6}$"
      }, null, 544)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("label", _hoisted_9, _toDisplayString(this.emailLabel) + " *", 1),
      _createElementVNode("input", {
        onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleSubmitBtn())),
        type: "text",
        id: "contact-email",
        ref: "email",
        name: "email-contact",
        required: "",
        pattern: "[^@ \\t\\r\\n]+@[^@ \\t\\r\\n]+\\.[^@ \\t\\r\\n]+"
      }, null, 544)
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("label", _hoisted_11, _toDisplayString(this.messageLabel) + " *", 1),
      _createElementVNode("textarea", {
        onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.toggleSubmitBtn())),
        type: "text",
        id: "contact-message",
        ref: "message",
        name: "message-contact",
        rows: "6",
        required: ""
      }, null, 544)
    ]),
    _createElementVNode("div", _hoisted_12, [
      _withDirectives(_createVNode(_component_vue_recaptcha, {
        onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.toggleSubmitBtn())),
        sitekey: _ctx.siteKey,
        size: "normal",
        theme: "light",
        onVerify: _ctx.recaptchaVerified,
        onExpire: _ctx.recaptchaExpired,
        onFail: _ctx.recaptchaFailed,
        ref: "vueRecaptcha"
      }, null, 8, ["sitekey", "onVerify", "onExpire", "onFail"]), [
        [_vShow, _ctx.showRecaptcha]
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("input", {
          onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.toggleSubmitBtn())),
          type: "checkbox",
          id: "contact-checkbox",
          ref: "checkbox",
          name: "checkbox-contact",
          required: "required"
        }, null, 544),
        _createElementVNode("label", _hoisted_14, _toDisplayString(this.gdprText), 1)
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("input", {
          type: "submit",
          ref: "submitButton",
          name: "submit",
          value: this.buttonLabel,
          onClick: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"])),
          disabled: ""
        }, null, 8, _hoisted_16)
      ])
    ])
  ], 8, _hoisted_1))
}